import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { AboutUsData } from "../../content.types";
import { requestGetAboutUs } from "./requestGetAboutUs.request";

const useGetAboutUs = (
  options?: QueryOptions<AboutUsData, ApiServiceError<ApiError>>
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["content-about-us"],
    queryFn: async () => await requestGetAboutUs(),
    onError: toastServerError,
    ...options
  });

  return { aboutUsData: data, ...rest };
};

export default useGetAboutUs;
